import { text } from '../nodes/text';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createTextNodes(nodes) {
  return nodes.map(createTextFromString);
}

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createTextFromString(str) {
  return typeof str === 'string' ? text(str) : str;
}